// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".intercom-messenger-frame>div.draggable-header{cursor:move;background-color:#333;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding-left:10px}.intercom-messenger-frame>div.draggable-header>svg{cursor:move;width:12px;height:12px}.intercom-messenger-frame>div.draggable-header>svg>path{fill:#fff}", ""]);
// Exports
module.exports = exports;
